import React from 'react';
import PropTypes from 'prop-types';

import styles from './Sidebar.module.scss';

const SidebarPosition = {
    Left: 'sidebar-left',
    Right: 'sidebar-right',
};

const Sidebar = ({ open, header, position, onClose, children }) => {
    const [startingX, setstartingX] = React.useState(0);
    const [movedX, setmovedX] = React.useState(0);

    const touchStart = (e) => {
        setstartingX(e.touches[0].clientX);
    };

    const touchMove = (e) => {
        setmovedX(e.touches[0].clientX);
    };

    /* istanbul ignore next */
    // TOODO cover touch end double condition
    const touchEnd = () => {
        const hasBeenMovedToTheLeft = startingX + 100 < movedX && movedX !== 0;
        const hasBeenMovedToTheRight = startingX - 100 > movedX && movedX !== 0;

        if (hasBeenMovedToTheLeft && position === SidebarPosition.Right) {
            onClose(false);
            setmovedX(0);
            setstartingX(0);
        } else if (hasBeenMovedToTheRight && position === SidebarPosition.Left) {
            onClose(false);
            setmovedX(0);
            setstartingX(0);
        }
    };

    return (
        <div
            onTouchStart={touchStart}
            onTouchMove={touchMove}
            onTouchEnd={touchEnd}
            className={`${styles['sidebar-component']} ${position ? styles[position] : ''} ${
                open ? styles['open'] : ''
            }`}
        >
            <div className={styles['sidebar-backdrop']} onClick={onClose} />
            <div className={styles['sidebar-content']}>
                <div className={styles['sidebar-header']}>{header}</div>
                <div className={styles['sidebar-close']} onClick={onClose}>
                    <i className='icon icon-close' />
                </div>
                <div className={styles['sidebar-body']}>{children}</div>
            </div>
        </div>
    );
};

Sidebar.propTypes = {
    open: PropTypes.bool,
    header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    position: PropTypes.oneOf([SidebarPosition.Left, SidebarPosition.Right]),
    onClose: PropTypes.func,
    children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.element),
    ]),
};

export default Sidebar;
export { SidebarPosition };
